const PostType = {
  Celebration: 'Celebration',
  UserPost: 'UserPost',
  Campaign: 'Campaign',
  NewsFeeds: 'NewsFeeds',
  Volunteering: 'Volunteering',
  Project: 'CampaignProject',
  CrowdFunding: 'CrowdFunding',
};

const CampaignType = {
  CollectGoods: 'CollectGoods',
  FundRaise: 'FundRaise',
  P2PFundRaise: 'P2PFundRaise',
};

const FundRaiseType = {
  FundRaise: 'FundRaise',
  P2PFundRaise: 'P2PFundRaise',
};

export default PostType;
export { CampaignType };
